module.exports = __webpack_public_path__ + "img/picto_plug_off.41f8cb94.png";